export default function isValidDate(date: Date | string): boolean {
  return !Number.isNaN(new Date(date).getTime());
}
